import { PlanState } from './types';

const state = (): PlanState => {
  return {
    plans: [],
  };
};

export default state;
